<template>
  <div id="app">
    <!-- <router-view v-if="isRouterAlive" /> -->
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
    <!-- <customer-service v-show="ishow"></customer-service> -->
    <el-dialog
      title="检查到新版本"
      :visible.sync="version.is_news"
      class="dialog-sm"
    >
      <span>{{ version.content }}</span>
      <el-row class="btn-group sm">
        <el-button type="primary" @click="update">确 定</el-button>
        <el-button type="info" @click="version.is_news = false"
          >取 消</el-button
        >
      </el-row>
    </el-dialog>
  </div>
</template>

<script>
import { service_const } from "@/assets/js/consts";
import {
  isSuccess,
  isLogin,
  openLogin,
  removeStorage,
} from "@/assets/js/utils";
import customerService from "@/components/customer/customer-service";
export default {
  name: "App",
  ishow: false,
  provide() {
    return {
      reload: this.reload(),
    };
  },
  data() {
    return {
      isRouterAlive: true,
      version: {
        is_news: false,
        content: "",
        is_refresh: "No",
      },
    };
  },

  watch: {
    $route(now, old) {
      if (
        now.path == "/oauth/account-login" ||
        now.path == "/oauth/register-personal" ||
        now.path == "/oauth/register-company" ||
        now.path == "/oauth/pay-forget"
      ) {
        this.ishow = false;
      }
    },
  },
  mounted() {},
  created() {
    this.checkVersion();
    this.submit();
    this.ishow = true;
    if (isLogin()) {
      this.ishow = true;
    } else {
      this.ishow = false;
    }
  },

  components: {
    customerService,
  },
  methods: {
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(function () {
        this.isRouterAlive = true;
      });
    },
    update() {
      this.version.is_news = false;
      alert("更新成功,请继续使用！", () => {
        window.location.reload();
      });
    },
    submit() {
      window.setInterval(() => {
        this.checkVersion();
      }, 60000);
    },
    //检查版本
    checkVersion() {
      if (!this.version.is_news) {
        api("version.check", {
          module_type: "Front",
          version_number: service_const.version,
        }).then((res) => {
          let data;
          if ((data = isSuccess(res))) {
            this.version = data;
            sessionStorage.setItem("imageStyle", data.image_style);
          }
        });
      }
      // if (isLogin()) {
      //   api('account.is.enable').then(res => {
      //     let data
      //     if (data = isSuccess(res)) {
      //       if (data.enable == true) {
      //         alert("抱歉，您的账号已被禁用，请联系管理员处理。")
      //         removeStorage(service_const.tokenKey)
      //         openLogin()
      //       }
      //     }
      //   })
      // }
    },
  },
};
</script>

<style>
#app {
  height: 100%;
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #333;
}
</style>



// WEBPACK FOOTER //
// src/App.vue